
export { MyLoadingComponent } from './myloading.component';
export { MyLoadingModule } from './myloading.module';
